import { Type } from 'class-transformer';
import { ContactInfoFieldDataResultDto } from './contact-info-field-data-result-dto';

export class ContactInfoPhoneResultDto {
  sequence: number;
  @Type(() => ContactInfoFieldDataResultDto)
  fieldData: Array<ContactInfoFieldDataResultDto>;
  isPrimary: boolean;
  // Transient or Computed field
  rowData: any;
}
